import { Errors as AgentEditorErrors, KnowledgeErrorType } from '@/state/agent';
import { rootStore } from '@/state/root/store';
import { AgentCreateTabType } from '@d-id/types';

const FILES_ERROR = "You haven't uploaded any files to your agent's knowledge base";

export const validateAgentGrounding = () => {
    const {
        agentEditorStore: { missingKnowledgeError, setCurrentTab, setErrorTabs, setErrors },
    } = rootStore;

    const errors: Partial<AgentEditorErrors> = {};

    if (missingKnowledgeError === KnowledgeErrorType.INPUT_TEXT) {
        errors.missingInputTextKnowledgeError = 'You haven’t added any text to your agent’s knowledge base';
    }

    if (missingKnowledgeError === KnowledgeErrorType.FILES) {
        errors.missingFilesError = FILES_ERROR;
    }

    if (Object.keys(errors).length > 0) {
        setErrorTabs([AgentCreateTabType.KnowledgeBase]);
        setCurrentTab(AgentCreateTabType.KnowledgeBase);
        setErrors(prev => ({ ...prev, ...errors }));
        return false;
    }

    return true;
};
